import {IState} from './model'

export const selectToken = ({login}: {login: IState}) => login.token



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./study_reviewer/src/store/login/selectors.ts